import React from "react";
import { historyDetailsItemsColumn } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import Translator from "Languages/Utility/Translator";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";

export default function HistoryDetailsItems({ loading, data }) {
  return (
    <>
      {data ? (
        <RemoteTable
          data={data}
          columns={historyDetailsItemsColumn}
          noTitle
          showPagination={false}
        />
      ) : (
        <div className="d-flex flex-row justify-content-center align-items-center ">
           {loading ? <InnerCircularProgress /> : <Translator id="noEditedItem" />}
        </div>
      )}
    </>
  );
}
